import { Component } from '@angular/core';

interface ControlValueAccessor {
  writeValue(obj: any): void;
  registerOnChange(fn: any): void;
  registerOnTouched(fn: any): void;
}

@Component({ template: '' })
export class BaseControlValueAccessorComponent implements ControlValueAccessor {
  value = null;

  onChange: (value: string) => void;
  onTouched: () => void;

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
